// @flow
import {
  FSS_ADDENDUM_CERT_TYPE,
  INITIAL_UT_CERT_TYPE,
  INTERIM_UT_CERT_TYPE,
  RECERT_UT_CERT_TYPE,
  determineCertTypeNameDefinitions,
} from './constants';

// ENG-30153: a converted combo transfer cert (RECERT_UT / INTERIM_UT / INITIAL_UT) shares its
// display label with the plain recert/initial/interim type — determineCertTypeNameDefinitions
// doesn't distinguish them — so append " + UT" to whatever that program-aware base label is,
// making the transfer distinguishable without hardcoding any program's wording. UNIT_TRANSFER
// itself already reads as a transfer and is left untouched.
const COMBINED_TRANSFER_CERT_TYPES = [
  RECERT_UT_CERT_TYPE,
  INTERIM_UT_CERT_TYPE,
  INITIAL_UT_CERT_TYPE,
];

export const getCertificationTypeDisplayValue = ({
  programName,
  certificationType,
  certificationTypeValue,
}: {
  programName: string,
  certificationType: string,
  certificationTypeValue: string,
}): string => {
  if (certificationType === FSS_ADDENDUM_CERT_TYPE) {
    return 'FSS Addendum Only';
  }

  if (COMBINED_TRANSFER_CERT_TYPES.includes(certificationType)) {
    const baseLabel =
      determineCertTypeNameDefinitions(programName)[certificationType];
    if (baseLabel) {
      return `${baseLabel} + UT`;
    }
  }

  return certificationTypeValue;
};
